import { COLUMN_FIELDS } from '../constants/table';

export const defaultColumnsCryptoStaticWallets = {
  [COLUMN_FIELDS.CURRENCY]: true,
  state: true,
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.EMAIL]: true,
  playerId: false,
  clientId: false,
  merchantId: false,
  [COLUMN_FIELDS.ADDRESS]: true,
  tag: true,
  [COLUMN_FIELDS.CREATED_AT]: true,
  updatedAt: false,
};

export const defaultColumnsSports = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.SHORT_NAME]: false,
  [COLUMN_FIELDS.POSITION]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.CASHOUT]: false,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsCompetitions = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.SPORT_ICON]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.SHORT_NAME]: false,
  [COLUMN_FIELDS.POSITION]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.CASHOUT]: false,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsTournaments = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.SPORT_ICON]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.SHORT_NAME]: false,
  [COLUMN_FIELDS.POSITION]: true,
  [COLUMN_FIELDS.LIVE_POSITION]: true,
  [COLUMN_FIELDS.TOP_LEAGUE]: false,
  [COLUMN_FIELDS.TOP_OFFER]: false,
  [COLUMN_FIELDS.TOP_OFFER_POSITION]: false,
  [COLUMN_FIELDS.FEATURED]: false,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.CASHOUT]: false,
  [COLUMN_FIELDS.INFORMATION]: false,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsParticipants = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.SHORT_NAME]: false,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.SPORT_ICON]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsPlayers = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.FIRST_NAME]: true,
  [COLUMN_FIELDS.LAST_NAME]: true,
  [COLUMN_FIELDS.DISPLAY_NAME]: false,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.SPORT_ICON]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: false,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: false,
  [COLUMN_FIELDS.PARTICIPANT_NAME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsMarkets = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.SPORT_ICON]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.SHORT_NAME]: true,
  [COLUMN_FIELDS.USED_FOR]: true,
  [COLUMN_FIELDS.TYPE]: true,
  [COLUMN_FIELDS.POSITION]: true,
  [COLUMN_FIELDS.DESCRIPTION]: false,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.CASHOUT]: false,
  [COLUMN_FIELDS.BET_BUILDER]: true,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsMarketGroups = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.SPORT_ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.POSITION]: true,
  [COLUMN_FIELDS.USED_FOR]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DISPLAY_TYPE]: true,
};

export const defaultColumnsMarketMix = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.SPORT_ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.POSITION]: true,
  [COLUMN_FIELDS.USED_FOR]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DISPLAY_TYPE]: true,
};

export const defaultColumnsOutcomes = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.MARKET_NAME]: true,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.SHORT_NAME]: false,
  [COLUMN_FIELDS.POSITION]: true,
  [COLUMN_FIELDS.DESCRIPTION]: false,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsEvents = {
  [COLUMN_FIELDS.SPORT_ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: false,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: true,
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.START_DATE]: true,
  [COLUMN_FIELDS.START_TIME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.CASHOUT]: false,
  [COLUMN_FIELDS.FEATURED]: false,
  [COLUMN_FIELDS.EDIT]: true,
  [COLUMN_FIELDS.INFORMATION]: false,
};
export const getDefaultColumnsLiveEvents = () => {
  const { [COLUMN_FIELDS.FEATURED]: _, ...columnsWithoutFeatured } = defaultColumnsEvents;
  return columnsWithoutFeatured;
};

export const defaultColumnsCustomers = {
  [COLUMN_FIELDS.FIRST_NAME]: true,
  [COLUMN_FIELDS.LAST_NAME]: true,
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.COUNTRY]: true,
  [COLUMN_FIELDS.PHONE_NUMBER]: true,
  [COLUMN_FIELDS.EMAIL]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.CREATED_AT]: true,
  [COLUMN_FIELDS.LAST_ONLINE]: true,
  [COLUMN_FIELDS.ADDRESS]: false,
  [COLUMN_FIELDS.ZIP_CODE]: false,
  [COLUMN_FIELDS.CITY]: false,
  [COLUMN_FIELDS.REGION]: false,
  [COLUMN_FIELDS.LANGUAGE]: false,
  [COLUMN_FIELDS.DATE_OF_BIRTH]: false,
  [COLUMN_FIELDS.GENDER]: false,
  [COLUMN_FIELDS.PARENT]: false,
  [COLUMN_FIELDS.CAMPAIGN]: true,
  [COLUMN_FIELDS.CREATED_BY]: false,
  [COLUMN_FIELDS.NATIONAL_ID]: false,
  [COLUMN_FIELDS.CURRENCY]: false,
  [COLUMN_FIELDS.EDIT]: true,
  [COLUMN_FIELDS.CASHOUT]: true,
};

export const defaultColumnsPartners = {
  [COLUMN_FIELDS.FULL_NAME]: true,
  [COLUMN_FIELDS.EMAIL]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.CREATED_AT]: true,
  [COLUMN_FIELDS.PARENT]: true,
  [COLUMN_FIELDS.ROLE]: true,
};

export const defaultColumnsResults = {
  [COLUMN_FIELDS.SPORT_ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.MODEL_MATCHES]: true,
  [COLUMN_FIELDS.PUBLISH_TIME_MATCHES]: true,
  [COLUMN_FIELDS.MODEL_OUTRIGHTS]: true,
  [COLUMN_FIELDS.PUBLISH_TIME_OUTRIGHTS]: true,
};

export const defaultColumnsResultsAndResolve = {
  [COLUMN_FIELDS.SPORT_ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: false,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: true,
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.START_TIME]: true,
  [COLUMN_FIELDS.RESULT]: true,
};

export const defaultColumnsConditionTypes = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.ENTITY]: true,
  [COLUMN_FIELDS.DESCRIPTION]: false,
  [COLUMN_FIELDS.RESTRICTION_MESSAGE_ADMIN]: false,
  [COLUMN_FIELDS.RESTRICTION_MESSAGE_CLIENT]: false,
  [COLUMN_FIELDS.VERIFICATION_MESSAGE_ADMIN]: false,
  [COLUMN_FIELDS.VERIFICATION_MESSAGE_CLIENT]: false,
};

export const defaultColumnsConditionGroups = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.ENTITY]: true,
  [COLUMN_FIELDS.DESCRIPTION]: false,
};

export const defaultColumnsSportConditions = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.CONDITION_GROUP_NAME]: true,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: false,
  [COLUMN_FIELDS.DESCRIPTION]: false,
};

export const defaultColumnsTournamentConditions = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.CONDITION_GROUP_NAME]: true,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: true,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
};

export const defaultColumnsCompetitionConditions = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.CONDITION_GROUP_NAME]: true,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
};

export const defaultColumnsAgentConditions = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.CONDITION_GROUP_NAME]: true,
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.FULL_NAME]: true,
  [COLUMN_FIELDS.EMAIL]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
};

export const defaultColumnsPunterConditions = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.CONDITION_GROUP_NAME]: true,
  [COLUMN_FIELDS.FIRST_NAME]: true,
  [COLUMN_FIELDS.LAST_NAME]: true,
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
};

export const defaultColumnsMarketConditions = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.CONDITION_GROUP_NAME]: true,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
};

export const defaultColumnsTicketConditions = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.CONDITION_GROUP_NAME]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
};

export const defaultColumnsBettingSlips = {
  [COLUMN_FIELDS.TICKET_ID]: true,
  [COLUMN_FIELDS.FROM]: true,
  [COLUMN_FIELDS.USER]: true,
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.TICKET_NO]: false,
  [COLUMN_FIELDS.AGENT]: false,
  [COLUMN_FIELDS.BETTING_OPERATOR]: false,
  [COLUMN_FIELDS.PRE_MATCH_RISK_FACTOR]: false,
  [COLUMN_FIELDS.IN_PLAY_RISK_FACTOR]: false,
  [COLUMN_FIELDS.CREATED_AT]: true,
  [COLUMN_FIELDS.PAID_OUT_AT]: false,
  [COLUMN_FIELDS.TOTAL_STAKE_AMOUNT]: true,
  [COLUMN_FIELDS.TOTAL_ODDS]: true,
  [COLUMN_FIELDS.BONUS_PERCENTAGE]: false,
  [COLUMN_FIELDS.RECEIVED_BONUS]: false,
  [COLUMN_FIELDS.POSSIBLE_WINNINGS]: false,
  [COLUMN_FIELDS.WINNINGS]: true,
  [COLUMN_FIELDS.JACKPOT_AMOUNT]: false,
  [COLUMN_FIELDS.COMBINATIONS_COUNT]: false,
  [COLUMN_FIELDS.CANCELED]: false,
  [COLUMN_FIELDS.REOFFERED]: false,
  [COLUMN_FIELDS.ACCEPT_STATUS]: true,
  [COLUMN_FIELDS.RESOLUTION_STATUS]: true,
  [COLUMN_FIELDS.SOURCE_IP]: false,
  [COLUMN_FIELDS.ACTIONS]: false,
  [COLUMN_FIELDS.CASHOUT]: true,
  [COLUMN_FIELDS.CASHOUT_AMOUNT]: false,
  [COLUMN_FIELDS.CASHOUT_TYPE]: false,
  [COLUMN_FIELDS.BET_BUILDER]: false,
};

export const defaultColumnsTicketAuthorization = {
  [COLUMN_FIELDS.TICKET_ID]: true,
  [COLUMN_FIELDS.CREATED_AT]: true,
  [COLUMN_FIELDS.TOTAL_STAKE_AMOUNT]: true,
  [COLUMN_FIELDS.TOTAL_ODDS]: false,
  [COLUMN_FIELDS.POSSIBLE_WINNINGS]: true,
  [COLUMN_FIELDS.BETS_COUNT]: true,
  [COLUMN_FIELDS.FROM]: false,
  [COLUMN_FIELDS.SOURCE_TYPE]: false,
  [COLUMN_FIELDS.USER]: false,
  [COLUMN_FIELDS.USERNAME]: true,
};

export const defaultColumnsTicketAuthorizationDetails = {
  [COLUMN_FIELDS.START_DATE]: true,
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.FROM]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: false,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: false,
  [COLUMN_FIELDS.EVENT]: true,
  [COLUMN_FIELDS.BANKER]: false,
  [COLUMN_FIELDS.IS_WAYS]: false,
  [COLUMN_FIELDS.MARKET]: true,
  [COLUMN_FIELDS.SPECIAL_VALUE]: true,
  [COLUMN_FIELDS.OUTCOME_SHORT_NAME]: true,
  [COLUMN_FIELDS.OUTCOME_NAME]: false,
  [COLUMN_FIELDS.ODDS]: true,
  [COLUMN_FIELDS.RESULT]: false,
  [COLUMN_FIELDS.BET_BUILDER]: true,
};

export const defaultColumnsSportsRiskManagement = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.RISK_FACTOR_ID]: true,
  [COLUMN_FIELDS.RISK_FACTOR_NAME]: false,
  [COLUMN_FIELDS.RISK_FACTOR_VALUE]: false,
  [COLUMN_FIELDS.MIN_VERIFICATION_TRIGGER]: true,
  [COLUMN_FIELDS.MAX_VERIFICATION_TRIGGER]: true,
  [COLUMN_FIELDS.LIABILITY_LIMIT_NAME]: true,
  [COLUMN_FIELDS.LIABILITY_LIMIT_VALUE]: true,
  [COLUMN_FIELDS.LIABILITY_CALCULATION]: false,
  [COLUMN_FIELDS.DEFAULT_RISK_FACTOR]: false,
  [COLUMN_FIELDS.DEFAULT_MIN_TRIGGER]: false,
  [COLUMN_FIELDS.DEFAULT_MAX_TRIGGER]: false,
};

export const defaultColumnsTournamentsRiskManagement = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: false,
  [COLUMN_FIELDS.COMPETITION_ID]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.TOURNAMENT_ID]: false,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: true,
  [COLUMN_FIELDS.RISK_FACTOR_ID]: false,
  [COLUMN_FIELDS.RISK_FACTOR_NAME]: false,
  [COLUMN_FIELDS.RISK_FACTOR_VALUE]: false,
  [COLUMN_FIELDS.MIN_VERIFICATION_TRIGGER]: true,
  [COLUMN_FIELDS.MAX_VERIFICATION_TRIGGER]: true,
  [COLUMN_FIELDS.LIABILITY_LIMIT_ID]: true,
  [COLUMN_FIELDS.LIABILITY_LIMIT_NAME]: false,
  [COLUMN_FIELDS.LIABILITY_LIMIT_VALUE]: false,
  [COLUMN_FIELDS.LIABILITY_CALCULATION]: false,
  [COLUMN_FIELDS.DEFAULT_RISK_FACTOR]: false,
  [COLUMN_FIELDS.DEFAULT_MIN_TRIGGER]: false,
  [COLUMN_FIELDS.DEFAULT_MAX_TRIGGER]: false,
};

export const defaultColumnsMarketsRiskManagement = {
  [COLUMN_FIELDS.SPORT_ID]: false,
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: true,
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.MARKET_NAME]: true,
  [COLUMN_FIELDS.RISK_FACTOR_ID]: true,
  [COLUMN_FIELDS.RISK_FACTOR_NAME]: false,
  [COLUMN_FIELDS.RISK_FACTOR_VALUE]: false,
  [COLUMN_FIELDS.LIABILITY_LIMIT_ID]: true,
  [COLUMN_FIELDS.LIABILITY_LIMIT_NAME]: false,
  [COLUMN_FIELDS.LIABILITY_LIMIT_VALUE]: false,
  [COLUMN_FIELDS.LIABILITY_CALCULATION]: false,
  [COLUMN_FIELDS.DEFAULT_RISK_FACTOR]: false,
  [COLUMN_FIELDS.MIN_VERIFICATION_TRIGGER]: false,
  [COLUMN_FIELDS.MAX_VERIFICATION_TRIGGER]: false,
};

export const defaultColumnsPlayersRiskManagement = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.FULL_NAME]: false,
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.RISK_FACTOR_ID]: true,
  [COLUMN_FIELDS.RISK_FACTOR_NAME]: false,
  [COLUMN_FIELDS.RISK_FACTOR_VALUE]: false,
  [COLUMN_FIELDS.MIN_VERIFICATION_TRIGGER]: true,
  [COLUMN_FIELDS.MAX_VERIFICATION_TRIGGER]: true,
  [COLUMN_FIELDS.LIABILITY_LIMIT_ID]: true,
  [COLUMN_FIELDS.LIABILITY_LIMIT_NAME]: false,
  [COLUMN_FIELDS.LIABILITY_LIMIT_VALUE]: false,
  [COLUMN_FIELDS.LIABILITY_CALCULATION]: false,
  [COLUMN_FIELDS.SETTINGS]: true,
  [COLUMN_FIELDS.DEFAULT_RISK_FACTOR]: false,
  [COLUMN_FIELDS.DEFAULT_MIN_TRIGGER]: false,
  [COLUMN_FIELDS.DEFAULT_MAX_TRIGGER]: false,
};

export const defaultColumnsLiabilityMonitoring = {
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: true,
  [COLUMN_FIELDS.EVENT]: true,
  [COLUMN_FIELDS.TOP_LIABILITY]: true,
  [COLUMN_FIELDS.LIABILITY_PERCENTAGE]: true,
  [COLUMN_FIELDS.SPORT_NAME]: false,
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.COMPETITION_ID]: false,
  [COLUMN_FIELDS.TOURNAMENT_ID]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: true,
  [COLUMN_FIELDS.EVENT_ID]: false,
  [COLUMN_FIELDS.UNIQUE_ID]: false,
  [COLUMN_FIELDS.START_DATE]: false,
  [COLUMN_FIELDS.LIMIT_ID]: false,
  [COLUMN_FIELDS.LIMIT_VALUE]: false,
  [COLUMN_FIELDS.RISK_FACTOR]: false,
  [COLUMN_FIELDS.NUMBER_TICKET_BETS]: true,
};

export const defaultColumnsTicketDetails = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.START_DATE]: true,
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.FROM]: true,
  [COLUMN_FIELDS.BANKER]: false,
  [COLUMN_FIELDS.MARKET_COMBINED]: false,
  [COLUMN_FIELDS.EVENT]: true,
  [COLUMN_FIELDS.MARKET]: true,
  [COLUMN_FIELDS.SPECIAL_VALUE]: true,
  [COLUMN_FIELDS.OUTCOME_SHORT_NAME]: true,
  [COLUMN_FIELDS.OUTCOME_NAME]: false,
  [COLUMN_FIELDS.IS_WAYS]: false,
  [COLUMN_FIELDS.ODDS]: true,
  [COLUMN_FIELDS.STATUS]: true,
  [COLUMN_FIELDS.RESULT]: false,
  [COLUMN_FIELDS.TOURNAMENT_NAME]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: false,
  [COLUMN_FIELDS.BET_BUILDER]: true,
};

export const defaultColumnsJackpots = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.ICON]: true,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.TYPE]: true,
  [COLUMN_FIELDS.WINNING_AMOUNT]: true,
  [COLUMN_FIELDS.STAKE_RANGES]: true,
  [COLUMN_FIELDS.WINNING_TICKETS]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsOutrights = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.SPORT_ICON]: true,
  [COLUMN_FIELDS.SPORT_NAME]: false,
  [COLUMN_FIELDS.COMPETITION_NAME]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.START_DATE]: true,
  [COLUMN_FIELDS.START_TIME]: true,
  [COLUMN_FIELDS.IS_ACTIVE]: true,
  [COLUMN_FIELDS.EDIT]: true,
  [COLUMN_FIELDS.INFORMATION]: false,
};

export const defaultColumnsBonuses = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.PRODUCT]: true,
  [COLUMN_FIELDS.STATUS]: true,
  [COLUMN_FIELDS.DESCRIPTION]: false,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsWelcomeBonus = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.PRODUCT]: true,
  [COLUMN_FIELDS.WELCOME_BONUS_SCOPE]: true,
  [COLUMN_FIELDS.STATUS]: true,
  [COLUMN_FIELDS.DESCRIPTION]: true,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsCampaigns = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.AFFILIATE]: true,
  [COLUMN_FIELDS.TYPE]: true,
  [COLUMN_FIELDS.PROMO_CODE]: true,
  [COLUMN_FIELDS.PRODUCT]: true,
  [COLUMN_FIELDS.BONUS_AMOUNT]: false,
  [COLUMN_FIELDS.BONUS_PERCENTAGE]: false,
  [COLUMN_FIELDS.CAP_LIMIT]: false,
  [COLUMN_FIELDS.MIN_DEPOSIT_AMOUNT]: false,
  [COLUMN_FIELDS.TIMEFRAME]: false,
  [COLUMN_FIELDS.SB_WAGERING]: false,
  [COLUMN_FIELDS.CASINO_WAGERING]: false,
  [COLUMN_FIELDS.STATUS]: true,
  [COLUMN_FIELDS.DESCRIPTION]: false,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsMarketplace = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.COUNTRY]: true,
  [COLUMN_FIELDS.CREATED_AT]: true,
  [COLUMN_FIELDS.CONTACT_NAME]: true,
  [COLUMN_FIELDS.STATUS]: true,
  [COLUMN_FIELDS.EDIT]: true,
};

export const defaultColumnsAgentReports = {
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.FULL_NAME]: false,
  [COLUMN_FIELDS.COMMISSION]: false,
  [COLUMN_FIELDS.PLAYERS_COUNT]: false,
  [COLUMN_FIELDS.BALANCE]: false,
  [COLUMN_FIELDS.TOTAL_STAKE]: false,
  [COLUMN_FIELDS.TOTAL_WINNINGS]: false,
  [COLUMN_FIELDS.JACKPOT_AMOUNT]: false,
  [COLUMN_FIELDS.TOTAL_PROFIT]: true,
  [COLUMN_FIELDS.TOTAL_COMMISSION]: true,
  [COLUMN_FIELDS.TOTAL_PROFIT_AFTER_COMMISSION]: true,
  [COLUMN_FIELDS.TICKETS_TOTAL]: true,
  [COLUMN_FIELDS.TICKETS_LOST]: true,
  [COLUMN_FIELDS.TICKETS_WON]: true,
  [COLUMN_FIELDS.TICKETS_OPEN]: true,
};

export const defaultColumnsAffiliateAgents = {
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.FULL_NAME]: false,
  [COLUMN_FIELDS.COMMISSION]: false,
  [COLUMN_FIELDS.COMMISSION_TYPE]: true,
  [COLUMN_FIELDS.PLAYERS_COUNT]: true,
  [COLUMN_FIELDS.BALANCE]: false,
  [COLUMN_FIELDS.TOTAL_STAKE]: true,
  [COLUMN_FIELDS.TOTAL_WINNINGS]: true,
  [COLUMN_FIELDS.JACKPOT_AMOUNT]: false,
  [COLUMN_FIELDS.TOTAL_PROFIT]: true,
  [COLUMN_FIELDS.NGR]: true,
  [COLUMN_FIELDS.TOTAL_COMMISSION]: true,
  [COLUMN_FIELDS.TOTAL_PROFIT_AFTER_COMMISSION]: false,
  [COLUMN_FIELDS.TICKETS_TOTAL]: true,
  [COLUMN_FIELDS.TICKETS_LOST]: false,
  [COLUMN_FIELDS.TICKETS_WON]: false,
  [COLUMN_FIELDS.TICKETS_OPEN]: false,
};

export const defaultColumnsManagersReports = {
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.FULL_NAME]: false,
  [COLUMN_FIELDS.PARTNERS_COUNT]: false,
  [COLUMN_FIELDS.PLAYERS_COUNT]: false,
  [COLUMN_FIELDS.BALANCE]: false,
  [COLUMN_FIELDS.TOTAL_STAKE]: false,
  [COLUMN_FIELDS.TOTAL_WINNINGS]: false,
  [COLUMN_FIELDS.JACKPOT_AMOUNT]: false,
  [COLUMN_FIELDS.TOTAL_PROFIT]: true,
  [COLUMN_FIELDS.TOTAL_COMMISSION]: true,
  [COLUMN_FIELDS.TOTAL_PROFIT_AFTER_COMMISSION]: true,
  [COLUMN_FIELDS.TICKETS_TOTAL]: true,
  [COLUMN_FIELDS.TICKETS_LOST]: true,
  [COLUMN_FIELDS.TICKETS_WON]: true,
  [COLUMN_FIELDS.TICKETS_OPEN]: true,
};

export const defaultColumnsAffiliateCampaignReports = {
  [COLUMN_FIELDS.ID]: false,
  [COLUMN_FIELDS.NAME]: true,
  [COLUMN_FIELDS.TYPE]: false,
  [COLUMN_FIELDS.CREATED_AT]: true,
  [COLUMN_FIELDS.PRODUCT]: false,
  [COLUMN_FIELDS.STATUS]: true,
  [COLUMN_FIELDS.CLICKS]: true,
  [COLUMN_FIELDS.UNIQUE_CLICKS]: false,
  [COLUMN_FIELDS.REGISTRATIONS]: true,
  [COLUMN_FIELDS.FIRST_DEPOSITS]: true,
  [COLUMN_FIELDS.FIRST_DEPOSIT_AMOUNT]: false,
  [COLUMN_FIELDS.WAGERING_SPORTSBOOK]: false,
  [COLUMN_FIELDS.WAGERING_CASINO]: false,
  [COLUMN_FIELDS.GGR]: true,
  [COLUMN_FIELDS.NGR]: true,
  [COLUMN_FIELDS.ACTIVE_PLAYERS]: false,
  [COLUMN_FIELDS.COMMISSION_EARNED]: true,
  [COLUMN_FIELDS.CONVERSION_RATE]: false,
  [COLUMN_FIELDS.EARNINGS_PER_CLICK]: false,
};

export const defaultColumnsApprovals = {
  [COLUMN_FIELDS.ID]: true,
  [COLUMN_FIELDS.USER_ID]: true,
  [COLUMN_FIELDS.FULL_NAME]: true,
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.EXECUTION_TIME]: true,
  [COLUMN_FIELDS.AMOUNT]: true,
  [COLUMN_FIELDS.PAYMENT_METHOD]: true,
  [COLUMN_FIELDS.STATUS]: true,
  [COLUMN_FIELDS.IBAN]: false,
  [COLUMN_FIELDS.SWIFT]: false,
  [COLUMN_FIELDS.BENEFICIARY_NAME]: false,
  [COLUMN_FIELDS.BANK_NAME]: false,
  [COLUMN_FIELDS.AUTH_RESULTS]: true,
  [COLUMN_FIELDS.CRYPTO_WITHDRAWAL]: true,
  [COLUMN_FIELDS.ACTIONS]: true,
};

export const defaultColumnsPlayersReports = {
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.COMMISSION]: true,
  [COLUMN_FIELDS.MAIN_TICKET_COUNT]: true,
  [COLUMN_FIELDS.BONUS_TICKET_COUNT]: true,
  [COLUMN_FIELDS.TOTAL_TICKET_COUNT]: true,
  [COLUMN_FIELDS.OPEN_TICKET_COUNT]: true,
  [COLUMN_FIELDS.WON_TICKET_COUNT]: true,
  [COLUMN_FIELDS.LOST_TICKET_COUNT]: true,
  [COLUMN_FIELDS.MAIN_STAKE_AMOUNT]: true,
  [COLUMN_FIELDS.BONUS_STAKE_AMOUNT]: true,
  [COLUMN_FIELDS.TOTAL_STAKE_AMOUNT]: true,
  [COLUMN_FIELDS.TOTAL_COMMISSION_AMOUNT]: true,
  [COLUMN_FIELDS.MAIN_WINNING_AMOUNT]: true,
  [COLUMN_FIELDS.BONUS_WINNING_AMOUNT]: true,
  [COLUMN_FIELDS.JACKPOT_AMOUNT]: true,
  [COLUMN_FIELDS.TOTAL_WINNING_AMOUNT]: true,
  [COLUMN_FIELDS.MAIN_PROFIT_AMOUNT]: true,
  [COLUMN_FIELDS.BONUS_PROFIT_AMOUNT]: true,
  [COLUMN_FIELDS.TOTAL_PROFIT_AMOUNT]: true,
  [COLUMN_FIELDS.NGR]: false,
  [COLUMN_FIELDS.PROFIT_MARGIN_PERCENTAGE]: true,
  [COLUMN_FIELDS.TOTAL_AFTER_COMMISSION]: true,
};

export const defaultColumnsAffiliatePlayers = {
  [COLUMN_FIELDS.USERNAME]: true,
  [COLUMN_FIELDS.COMMISSION]: false,
  [COLUMN_FIELDS.MAIN_TICKET_COUNT]: true,
  [COLUMN_FIELDS.BONUS_TICKET_COUNT]: false,
  [COLUMN_FIELDS.TOTAL_TICKET_COUNT]: false,
  [COLUMN_FIELDS.OPEN_TICKET_COUNT]: false,
  [COLUMN_FIELDS.WON_TICKET_COUNT]: false,
  [COLUMN_FIELDS.LOST_TICKET_COUNT]: false,
  [COLUMN_FIELDS.MAIN_STAKE_AMOUNT]: true,
  [COLUMN_FIELDS.BONUS_STAKE_AMOUNT]: false,
  [COLUMN_FIELDS.TOTAL_STAKE_AMOUNT]: false,
  [COLUMN_FIELDS.TOTAL_COMMISSION_AMOUNT]: false,
  [COLUMN_FIELDS.MAIN_WINNING_AMOUNT]: true,
  [COLUMN_FIELDS.BONUS_WINNING_AMOUNT]: false,
  [COLUMN_FIELDS.JACKPOT_AMOUNT]: false,
  [COLUMN_FIELDS.TOTAL_WINNING_AMOUNT]: false,
  [COLUMN_FIELDS.MAIN_PROFIT_AMOUNT]: true,
  [COLUMN_FIELDS.BONUS_PROFIT_AMOUNT]: false,
  [COLUMN_FIELDS.TOTAL_PROFIT_AMOUNT]: false,
  [COLUMN_FIELDS.NGR]: true,
  [COLUMN_FIELDS.PROFIT_MARGIN_PERCENTAGE]: false,
  [COLUMN_FIELDS.TOTAL_AFTER_COMMISSION]: false,
};
